import {
    mapActions,
    mapGetters
} from 'vuex';
import ApercuPanierI18n from './ApercuPanier.i18n.js';

export default {

    components: {},

    props: {
        isAccueil: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        ...mapGetters(['cart', 'familleArticles','priceHiddenMode']),
        /**
         * Panier trié.
         * @returns
         */
        cartTrie() {
            let cartTrieParFamille = {}
            this.cart.forEach(element => {
                if (cartTrieParFamille[element.Famille] == undefined) {
                    cartTrieParFamille[element.Famille] = []
                }
                cartTrieParFamille[element.Famille].push(element)
            });
            return cartTrieParFamille
        },
        /**
         * Total HT du panier (brut + port)
         * @returns
         */
        TOTAL_HT() {
            return parseFloat(this.Brut_HT) + this.PORT_HT;
        },

        /**
         * Total TTC du panier (total HT * 1.2)
         * @returns
         */
        TTC() {
            return this.TOTAL_HT * 1.2;
        },

        /**
         * Total HT sans frais de port
         * @returns
         */
        Brut_HT() {
            let total = 0
            this.cart.forEach(element => {
                total = total + element.PT
            })
            return total
        },

        /**
         * Frais de port en fonction du Brut_HT.
         * @returns
         */
        PORT_HT() {
            let PortHT = 0.00;
            const ind = this.cart.findIndex(element => {
                return ['PLA.', 'FLE.', 'ACCESSOIRE.'].includes(element.Famille)
            });
            //s'il n'y a pas que des inters et bronzes
            if (ind >= 0) {
                if (this.Brut_HT < 51) {
                    PortHT = 30
                } else if (this.Brut_HT >= 51 && this.Brut_HT < 101) {
                    PortHT = 35
                } else if (this.Brut_HT >= 101 && this.Brut_HT < 151) {
                    PortHT = 40
                } else if (this.Brut_HT >= 151 && this.Brut_HT < 201) {
                    PortHT = 45
                } else if (this.Brut_HT >= 201 && this.Brut_HT < 251) {
                    PortHT = 50
                } else if (this.Brut_HT >= 251 && this.Brut_HT < 301) {
                    PortHT = 55
                } else if (this.Brut_HT >= 301 && this.Brut_HT < 351) {
                    PortHT = 60
                } else if (this.Brut_HT >= 351 && this.Brut_HT < 401) {
                    PortHT = 65
                } else if (this.Brut_HT >= 401 && this.Brut_HT < 451) {
                    PortHT = 70
                } else if (this.Brut_HT >= 451 && this.Brut_HT < 501) {
                    PortHT = 75
                } else {
                    PortHT = 0 //Franco de port
                }

                // s'il n'y a que des inter et bronzes
            } else {
                //Calcul port sur total commande
                if (this.Brut_HT >= 1000) {
                    PortHT = 0
                } else {
                    PortHT = (this.Brut_HT * 0.15)
                }
            }

            return parseFloat(PortHT)
        },
    },

    data() {
        return {
            isPanierDisplayed: false,
            isPlaqueOpen: false,
            isFleursOpen: false,
            isAccesoiresOpen: false,
            isInterOpen: false,
            isBronzeOpen: false
        };
    },

    watch: {},

    methods: {
        ...mapActions(['getFamilleArticles']),
        /**
         * Fonction pour afficher/cacher le panier.
         */
        toggleDisplayCart() {
            this.isPanierDisplayed = !this.isPanierDisplayed
        },

        /**
         * Fonction pour récupérer le nom complet de la famille d'articles.
         * @param {*} CodeFam
         */
        getFamilleName(CodeFam) {
            let name = ''
            this.familleArticles.forEach(aFamille => {
                if (aFamille.Code === CodeFam) {
                    name = aFamille.Nom
                }
            })
            return name
        },
        /**
         * Fonction pour aller au panier.
         */
        goToPanier() {
            this.$router.push('panier')
        },
        /**
         * Function to open/close accordeon.
         * @param {*} CodeFam
         */
        toggleAccordeon(CodeFam) {
            if (CodeFam === 'PLA.') {
                this.isPlaqueOpen = !this.isPlaqueOpen
            } else if (CodeFam === 'FLE.') {
                this.isFleursOpen = !this.isFleursOpen
            } else if (CodeFam === 'ACCESSOIRE.') {
                this.isAccesoiresOpen = !this.isAccesoiresOpen
            } else if (CodeFam === 'BRONZE.') {
                this.isBronzeOpen = !this.isBronzeOpen
            } else if (CodeFam === 'INTER.') {
                this.isInterOpen = !this.isInterOpen
            }
        },
        isFamilleHidden(CodeFam) {
            if (CodeFam === 'PLA.') {
                return !this.isPlaqueOpen
            } else if (CodeFam === 'FLE.') {
                return !this.isFleursOpen
            } else if (CodeFam === 'ACCESSOIRE.') {
                return !this.isAccesoiresOpen
            } else if (CodeFam === 'BRONZE.') {
                return !this.isBronzeOpen
            } else if (CodeFam === 'INTER.') {
                return !this.isInterOpen
            }
        }
    },

    filters: {
        formatNumber: (pValue) => {
            return parseFloat(pValue).toLocaleString('fr-FR', {
                style: "currency",
                currency: "EUR"
            })
        },
    },


    mounted() {
        // Récuperation des famille articles
        this.getFamilleArticles().then(res => {}).catch(err => {
            console.log(err)
        })
    },

    i18n: ApercuPanierI18n,

};
